document.addEventListener('DOMContentLoaded', function () {
    const dropdownToggles = document.querySelectorAll('.nav-item-dropdown .dropdown-toggle');
    
    dropdownToggles.forEach(toggle => {
        toggle.addEventListener('click', function(e) {
            // Only affect mobile/tablet touch behavior
            if (window.innerWidth < 992) {
                const parent = this.closest('.nav-item-dropdown');
                
                // If menu is not open, prevent link navigation and open the menu
                if (!parent.classList.contains('is-open')) {
                    e.preventDefault();
                    
                    // Close other dropdowns first (accordion style)
                    document.querySelectorAll('.nav-item-dropdown.is-open').forEach(openDropdown => {
                        if (openDropdown !== parent) {
                            openDropdown.classList.remove('is-open');
                        }
                    });

                    parent.classList.add('is-open');
                }
                // If it IS open, let the user click through to the link!
            }
        });
    });

    // Close mega menu + lang/country dropdowns when clicking outside
    document.addEventListener('click', function (e) {
        if (!e.target.closest('.nav-item-dropdown')) {
            document.querySelectorAll('.nav-item-dropdown.is-open').forEach(function (dropdown) {
                dropdown.classList.remove('is-open');
            });
        }

        document.querySelectorAll('.lang-selector, .mobile-lang-selector').forEach(function (wrap) {
            var dd = wrap.querySelector('.lang-dropdown');
            if (dd && !wrap.contains(e.target)) {
                dd.style.display = 'none';
            }
        });

        document.querySelectorAll('.footer-tools .custom-select-box').forEach(function (box) {
            var dd = box.querySelector('.custom-select-dropdown');
            if (dd && !box.contains(e.target)) {
                dd.style.display = 'none';
            }
        });
    });

    // Mobile Menu Toggle
    const mobileMenuBtn = document.querySelector('.btn-menu-toggle');
    const mobileMenuCloseBtn = document.querySelector('.mobile-menu-close');
    const header = document.querySelector('.header');

    if (mobileMenuBtn) {
        mobileMenuBtn.addEventListener('click', () => {
            header.classList.add('is-open');
            document.body.style.overflow = 'hidden'; // prevent background scrolling
        });
    }

    if (mobileMenuCloseBtn) {
        mobileMenuCloseBtn.addEventListener('click', () => {
            header.classList.remove('is-open');
            document.body.style.overflow = '';
        });
    }
});
